module.exports = __webpack_public_path__ + "static/dp-princip-6-6e46cfa546196b2bd56ec8a6c092dcad.svg";